// @ts-nocheck

import { createSelector } from 'reselect';

import { getIsMultichoiceFromProps } from '../../selectors/_propsGetters_';
import { selectEntitiesBetsEntityBetTitle } from '../../selectors/entities/bets/entitiesBetsPrimary.selector';
import { selectEntitiesOutcomesEntityLabel } from '../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';
import { selectMatchViewMode } from '../../selectors/match.selector';
import BetBuilder from '../../states/betbuilder';
import { MatchViewModes } from '../../types/matchView';

const makeMatchHotBetGroupOutcomePropsSelector = () => {
  const selectBetName = createSelector(
    [selectEntitiesBetsEntityBetTitle, getIsMultichoiceFromProps, selectMatchViewMode],
    (betName, isMultichoice, matchViewMode) =>
      isMultichoice && matchViewMode === MatchViewModes.MY_MATCH ? BetBuilder.addBetTitlePrefix(betName) : betName,
  );
  return createSelector(
    [selectBetName, selectEntitiesOutcomesEntityLabel, selectMatchViewMode],
    (betName, outcomeName, matchViewMode) => ({
      betName,
      outcomeName,
      matchViewMode,
    }),
  );
};

export default makeMatchHotBetGroupOutcomePropsSelector;
